import React from 'react'
import { CheckIcon, Close } from 'icons'

export const statusIconsMap = {
  done: <CheckIcon />,
  failed: <Close />,
}
